import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import axios from "axios";
import '../../App.css';


export default function OviewTasks() {
    useEffect(() => {
        document.title = "Tasks"; // Set the tab name
    }, []);

    const [example_data, setExample] = useState([
        {
            assignee: {
                name: "Yosef",
                email: "yosef@mail.com",
            },
            title: "Setup Meeting Room",
            location: "Conference Room #1",
            status: "In Progress",
        },
        {
            assignee: {
                name: "Ben",
                email: "ben@mail.com",
            },
            title: "Conduct Inventory",
            location: "Registrar's Office",
            status: "Done",
        }        
    ]);

      // for testing, set tasks_data initial state to example_data
    const [tasks_data, setTasks] = useState(example_data);

    useEffect(() => {
        axios.get('https://docuquest-swu.swucite.tech/api_drts/tasks.php')
        .then((response)=> {            
            const tasks = response.data.map(report => ({
                // TODO
                
            }));
            
            setTasks(tasks);
        }).catch((err)=> {
            //console.error("ERROR: ",err)
        });        
        
    }, [tasks_data]);

    const [searchValue, setSearchValue] = useState("");

    const [dataCounts, setDataCounts] = useState({
        total: 0,
        unassigned: 0
    });

    const [updateTrigger, setUpdateTrigger] = useState(false);

    useEffect(() => {
      const fetchDataCounts = async () => {
        try {
          const response = await axios.get('https://docuquest-swu.swucite.tech/api_drts/your-endpoint.php'); // TODO refer to api folder in htdocs
          setDataCounts(response.data);
        } catch (error) {
          //console.error("Error fetching data counts:", error);
        }
      };
  
      fetchDataCounts();
    }, [updateTrigger]); // Only calls when updateTrigger changes
    
    const handleSearchChange = (e) => {
        const searchQuery = e.target.value.toLowerCase();
        setSearchValue(searchQuery);
    
        const filteredBySearch = example_data.filter((request) =>
            Object.values(request).some((val) =>
                typeof val === "string"
                    ? val.toLowerCase().includes(searchQuery)
                    : typeof val === "object"
                    ? Object.values(val)
                          .some((nestedVal) =>
                              String(nestedVal).toLowerCase().includes(searchQuery)
                          )
                    : false
            )
        );
    
        setTasks(filteredBySearch);
        setPageNow(1);
    };

    const [pageNow, setPageNow] = useState(1);
    const rowsNow = 15;
    const indxLast = pageNow * rowsNow;
    const indxFirst = indxLast - rowsNow;
  
    const paginatedTasks = tasks_data.slice(indxFirst, indxLast);
    const pageTotal = Math.ceil(tasks_data.length / rowsNow);
    const pageNumbers = [...Array(pageTotal + 1).keys()].slice(1);
  
    const pagePrev = () => {
      if (pageNow > 1) setPageNow(pageNow - 1);
    };
  
    const pageNext = () => {
      if (pageNow < pageTotal) setPageNow(pageNow + 1);
    };
  
    const changePage = (id) => {
      setPageNow(id);
    };

    const refreshTopData = () => {
        setUpdateTrigger(!updateTrigger);
    };

    const navigate = useNavigate();

    const handleNavigation = (path) => {
        navigate(path);
    };
    
    return (
        <div>
            <header className="header">
                <input 
                   type="text"
                   placeholder="Search"
                   value={searchValue}
                   onChange={handleSearchChange}
                   className="search-input right"   
                />
            </header>
            {/* TODO class for section where the 2 stat_box will fill the width */}
            <section className='dash_overview'>
                <article className='stat_box standalone'>
                    <h6 className='title'>Completed</h6>
                    <p className='title body'>{dataCounts.total}</p>
                </article>
                <article className='stat_box standalone'>
                    <h6 className='title'>Unassigned</h6>
                    <p className='title body'>{dataCounts.unassigned}</p>
                </article>
            </section>

            <table className="documents-table">
                <thead>
                {tasks_data.length > 0 && (
                    <tr>
                    <th>Assignee</th>
                    <th>Title</th>
                    <th>Location</th>
                    <th>Task&nbsp;Status</th>
                    </tr>
                )}
                </thead>
                <tbody>
                {/* TODO clicking on name leads to profile, just ike user mgmt */}
                {paginatedTasks.map((task, index) => (
                    <tr key={index}>
                        <td>
                            <div className="requester-info">
                                <img
                                    src="https://via.placeholder.com/40"
                                    alt="Avatar"
                                    className="avatar"
                                />
                                <div>
                                    <div>{task.assignee.name}</div>
                                    <div className="role">{task.assignee.email}</div>
                                </div>
                            </div>
                        </td>
                        <td>{task.title}</td>
                        <td>{task.location}</td>
                        <td className={`status ${task.status.toLowerCase().replace(' ', '-')}`}>
                            {task.status}
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
            {
            paginatedTasks.length > 0 && (
                <div className="pagination">
                    <button onClick={() => changePage(1)} disabled={pageNow === 1}>
                        &lt;&lt;
                    </button>
                    <button onClick={pagePrev} disabled={pageNow === 1}>
                        &lt; Previous
                    </button>
                    {pageNumbers.map((number) => (
                        <button
                        key={number}
                        onClick={() => changePage(number)}
                        className={pageNow === number ? "active" : ""}
                        >
                        {number}
                        </button>
                    ))}
                    <button onClick={pageNext} disabled={pageNow === pageTotal}>
                        Next &gt;
                    </button>
                    <button onClick={() => changePage(pageTotal)} disabled={pageNow === pageTotal}>
                        &gt;&gt;
                    </button>
                </div>
            )}
        </div>
    );
}